import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
	TemplateRef,
	ViewChild
} from '@angular/core';

import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {OrderType} from 'src/app/models/OrderType';
import {PaymentMethod} from 'src/app/models/PaymentMethod';
import {PreorderType} from 'src/app/models/PreorderType';
import {TerminalorderType} from 'src/app/models/TerminalorderType';
import {numberToCurrency, OrderService} from 'src/app/services/order.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
	selector: 'app-order-item-header-info',
	templateUrl: './order-item-header-info.component.html',
	styleUrls: ['./order-item-header-info.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderItemHeaderInfoComponent implements OnInit {
	@ViewChild('qrDialog') qrDialog!: TemplateRef<unknown>;

	public order: Order;
	public orderPool: OrderPool;
	numberToCurrency = numberToCurrency;
	public type: PreorderType | TerminalorderType | null;
	public paymentMethod: PaymentMethod | null;
	public paymentMethodEnum = PaymentMethod;
	public orderType = OrderType;

	@Input() set orderValue(value: Order | OrderPool) {
		if (value) {
			if (this.checkIfOrder(value)) {
				this.order = value;
				this.type = this.orderService.getOrderPreorderOrTerminalType(value);
				this.paymentMethod = this.orderService.getPaymentMethod(value);
			}
			if (this.checkIfOrderPool(value)) {
				this.orderPool = value;
				this.type = null;
				this.paymentMethod = null;
			}
		}
	}

	constructor(
		private orderService: OrderService,
		private dialog: MatDialog
	) {}

	ngOnInit() {}

	getColorByMethod(method: PaymentMethod | null) {
		switch (method) {
			case PaymentMethod.CASH:
				return '#1F3A7F';

			case PaymentMethod.CREDIT_CARD:
				return '#8480BB';

			default:
				return '#1F3A7F';
		}
	}

	checkIfOrder(value: Order | OrderPool): value is Order {
		return (value as Order)?.orderedArticles != undefined;
	}

	checkIfOrderPool(value: Order | OrderPool): value is OrderPool {
		return (
			(value as OrderPool)?.dndCompany != undefined &&
			(value as OrderPool)?.orders != undefined
		);
	}

	openQrDialog(qrData: string): void {
		this.dialog.open(this.qrDialog, {
			width: '300px',
			data: {qrData},
			autoFocus: false,
			restoreFocus: false
		});
	}
}
